/**
 * Fetcher untuk shipping-rates domain (tarif/cost).
 *
 * Pure functions — terima params, return Promise<data>.
 * Dipakai oleh composable di src/composables/shipping/*.
 */
import http from "@/config/http";

/* List tarif (cost) — biasa untuk halaman tariff list. */
export async function fetchShippingCosts(params = {}) {
  const { data } = await http.get("/api/v1/shipping-rates/cost", { params });
  return data;
}

/* Detail tarif by id — untuk modal edit. */
export async function fetchShippingCostById(id) {
  const { data } = await http.get(`/api/v1/shipping-rates/cost/get/${id}`);
  return data;
}
